export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-strikethrough-52441020180e9c616a9fadd04ddf7c70.svg";